export default "__VITE_ASSET__CL4wyypR__"